import React from 'react'
import Header from '../../../Components/Header'

function Wargear() {
    return (
        <div>
            <Header text={"Wargear Options"} link={'/datasheet/wargear'} />
            <div>
                Data
            </div> <br />
        </div>
    )
}

export default Wargear